import { Input, Badge } from 'antd';
import ArrowLeftIcon from 'assets/icons/arrow-left';
import NotificationIcon from 'assets/icons/notification-icon';
// import SearchIcon from 'assets/icons/search';
import { useNavigate } from 'react-router';
import React from 'react';

interface HeaderProps {
  allowBack?: boolean;
  title: string;
  subtitle?: string;
  backDestinationPath?: string;
  backNavigationState?: object;
}

const Header: React.FC<HeaderProps> = ({
  allowBack = true,
  title,
  subtitle,
  backDestinationPath,
  backNavigationState,
}) => {
  const navigate = useNavigate();
  return (
    <header className="flex items-center justify-between py-4">
      <div className="flex items-center gap-4">
        {allowBack && (
          <button
            onClick={
              backDestinationPath
                ? () =>
                    navigate(backDestinationPath, {
                      state: backNavigationState,
                    })
                : () => navigate(-1)
            }
            className="w-10 h-10 flex items-center justify-center bg-[#1d67b6] rounded-md hover:bg-[#1d67b6]/90 transition-colors"
          >
            <ArrowLeftIcon />
          </button>
        )}
        <div className="flex flex-col">
          <h1 className="text-2xl font-semibold">{title}</h1>
          <span className="text-[#5E6B7C] mt-1">{subtitle}</span>
        </div>
      </div>

      <div className="flex items-center gap-6">
        {/* Temporary remove this input until find out its usage */}
        {/* <Input
          prefix={<SearchIcon />}
          placeholder="Search"
          size="large"
          className="w-[300px] h-[40px] rounded-md shadow-md"
        /> */}
        <div className="relative">
          <Badge count={5}>
            <button className="shadow-md w-10 h-10 flex items-center justify-center bg-white/10 rounded-md hover:bg-white/20 transition-colors border border-[#e4e7eb]">
              <NotificationIcon />
            </button>
          </Badge>
        </div>
      </div>
    </header>
  );
};

export default Header;
